import { Template } from "../view/Template";

export interface Scope {
	prepareContent( node:Element, template:Template );
}

/**
 * A guard that checks whether the specified object is a [[Scope]].
 *
 * @param obj The object that should be tested.
 */
export function isScope( obj:any ):obj is Scope {
	return obj && obj[ 'prepareContent' ];
}

